import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import Feature from 'ol/Feature';
import StyleFunction from 'ol/style/Style';
import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer } from 'ol/layer';
import { MapComponent } from '../map.component';

@Component({
    selector: 'app-polygon-layer',
    template: ''
})
export class PolygonLayerComponent implements OnInit, OnChanges, OnDestroy {

    @Input() id: string;
    @Input() visible: boolean;
    @Input() features: Feature[];
    @Input() styleFunction: StyleFunction;

    vectorLayer: VectorLayer;

    constructor(
        private _map: MapComponent
    ) { }

    ngOnInit(): void {
        this.vectorLayer = this.initializeVectorLayer();
        this._map.instance.addLayer(this.vectorLayer);
        if (this.id) {
            this.vectorLayer.set('id', this.id);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.vectorLayer) {
            return;
        }
        if ('features' in changes) {
            this.vectorLayer.getSource().clear();
            this.vectorLayer.getSource().addFeatures(this.features);
        }
        if ('visible' in changes) {
            this.vectorLayer.setVisible(this.visible);
        }
    }

    ngOnDestroy(): void {
        this.vectorLayer.getSource().clear();
        this._map.instance.removeLayer(this.vectorLayer);
    }

    initializeVectorLayer(): VectorLayer {
        return new VectorLayer({
            visible: this.visible,
            source: new VectorSource({
                features: this.features ? this.features : [],
            }),
            style: this.styleFunction ? this.styleFunction : undefined
        });
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/layers/polygon-layer-component.ts